export const getFoldersSuccess = folders=> ({
    type: 'FOLDERS_RECEIVED',
    payload: {
        folders
    }
});
